<template>
  <svg
    id="customer-care"
    xmlns="http://www.w3.org/2000/svg"
    enable-background="new 0 0 512 512"
    viewBox="0 0 512 512"
    :height="height"
    :width="width"
    :style="iconStyle"
  >
    <g>
      <g>
        <g>
          <path
            d="M466 428.5h-67.5c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5H466c4.143 0 7.5-3.357 7.5-7.5S470.143 428.5 466 428.5zM113.5 428.5H46c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h67.5c4.143 0 7.5-3.357 7.5-7.5S117.643 428.5 113.5 428.5zM391 136C391 61.561 330.439 1 256 1c-74.629 0-135 60.39-135 135v7.5c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5V136c0-66.458 53.812-120 120-120 66.168 0 120 53.832 120 120v7.5c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5V136zM300.81 471.822c-2.595-11.31-19.291-84.086-23.603-102.881l9.692-27.609c1.372-3.908-.684-8.189-4.592-9.561-3.91-1.374-8.189.686-9.561 4.592L264.098 361h-16.195l-8.648-24.637c-1.371-3.908-5.649-5.967-9.561-4.592-3.908 1.371-5.964 5.652-4.592 9.561l9.692 27.609-23.604 102.882c-.644 2.807.377 5.734 2.625 7.533l37.5 30c2.74 2.191 6.631 2.191 9.371 0l37.5-30C300.435 477.558 301.454 474.629 300.81 471.822zM256 493.896l-29.137-23.31L248.564 376h14.871c2.311 10.074 16.89 73.62 21.7 94.587L256 493.896z"
          ></path>
          <path
            d="M414.527,297.39L308.5,283.895v-19.49c7.626-4.421,14.644-9.777,20.904-15.905H376
				c4.143,0,7.5-3.357,7.5-7.5v-28.521c13.422-7.773,22.5-22.218,22.5-38.979c0-24.813-20.187-45-45-45h-0.271
				C356.885,74.285,311.563,31,256,31c-55.585,0-100.884,43.295-104.729,97.5H151c-24.679,0-45,19.943-45,45
				c0,24.813,20.187,45,45,45h10.145c9.164,19.238,24.009,35.268,42.355,45.905v19.49L97.474,297.39
				c-33.62,4.275-58.974,33.062-58.974,66.96V503.5c0,4.143,3.357,7.5,7.5,7.5c14.656,0,404.917,0,420,0c4.143,0,7.5-3.357,7.5-7.5
				c0-22.626,0-101.026,0-139.15C473.5,330.451,448.146,301.665,414.527,297.39z M151,203.5c-16.542,0-30-13.458-30-30
				c0-16.712,13.55-30,30-30c0.718,23.652-2.171,38.085,4.374,60H151z M323.053,300.868l-30.859,38.776l-23.548-20.176
				l34.134-21.181L323.053,300.868z M256,309.663l-37.5-23.27v-14.821c24.061,9.232,50.888,9.251,75,0v14.821L256,309.663z
				 M361,173.5v-30c16.542,0,30,13.458,30,30c0,16.712-13.55,30-30,30h-4.374C359.467,193.99,361,183.921,361,173.5z M368.5,217.868
				V233.5h-26.382c3.307-4.731,6.235-9.745,8.738-15C359.552,218.373,362.655,218.844,368.5,217.868z M256,46
				c41.86,0,77.136,28.726,87.152,67.5c-1.687-0.383-36.542,4.194-58.112-28.16c-2.965-4.45-9.516-4.448-12.48,0
				c-11.98,17.973-31.955,28.16-52.619,28.16h-51.093C178.864,74.726,214.14,46,256,46z M166,173.5
				c0.097-37.501-0.228-38.449,0.315-45h53.625c22.051,0,43.655-9.356,58.854-26.691c27.368,31.302,64.02,26.151,66.891,26.691
				c0.546,6.585,0.22,8.219,0.315,45c0,23.031-8.7,44.065-22.98,60H256c-4.143,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h49.69
				c-14.249,9.472-31.335,15-49.69,15C206.374,263.5,166,223.126,166,173.5z M209.22,298.288l34.134,21.181l-23.548,20.176
				l-30.859-38.776L209.22,298.288z M458.5,496H406v-90c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v90c-30.401,0-240.98,0-270,0
				v-90c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v90H53.5V364.35c0-26.365,19.718-48.755,45.867-52.079l72.174-9.187
				l41.371,51.987c2.637,3.316,7.512,3.796,10.748,1.025L256,328.386l32.34,27.709c3.212,2.752,8.093,2.313,10.748-1.025
				l41.371-51.987l72.175,9.187c26.148,3.324,45.866,25.714,45.866,52.079C458.5,409.553,458.5,468.909,458.5,496z"
          ></path>
          <path
            d="M218.5 151h-15c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h15c4.143 0 7.5-3.357 7.5-7.5S222.643 151 218.5 151zM293.5 166h15c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-15c-4.143 0-7.5 3.357-7.5 7.5S289.357 166 293.5 166z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '20',
    },
    width: {
      type: String,
      default: '20',
    },
    color: {
      type: String,
      default: 'primary-gray-600',
    },
  },
  computed: {
    /**
     * Icon Style
     * @param {void}
     * @returns {string} - Color
     * @description Assigns the specific color to the icon
     */
    iconStyle() {
      return {
        fill: `var(--${this.color})`,
        stroke: `var(--${this.color})`,
        strokeWidth: '2px',
      }
    },
  },
}
</script>
